import { dynamicFormApiConnector } from 'apiConnector/form/dynamic';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { EMPTY, throwError } from 'rxjs';
import { catchError, mergeMap, timeoutWith, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';

export interface CloseDynamicFormEpicApi {
  closeSession(negotiationId: string, productType: string, productSubtype: string): Observable<void>;
}

export function closeDynamicFormEpic(timeoutInMillis: number = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$, { oldHttpClient, frontLogger, selectors: { getDynamicFormInfos } }) =>
    action$.pipe(
      ofType('WORKSPACE_TAB_DELETE_SESSION_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ id }, state]) => {
        const dynamicFormInfos = getDynamicFormInfos(state, id);

        if (!dynamicFormInfos) {
          return EMPTY;
        }

        const { negotiationId, instrumentName, instrumentContractName } = dynamicFormInfos;

        return negotiationId
          ? dynamicFormApiConnector(oldHttpClient)
              .closeSession(negotiationId, instrumentName, instrumentContractName)
              .pipe(
                mergeMap(() => EMPTY),
                timeoutWith(timeoutInMillis, throwError(new Error(`timeouted`)), appScheduler),
                catchError(error => {
                  frontLogger.error('Close dynamic tab {TabId} session {@FrontError}', id, error);
                  return EMPTY;
                }),
              )
          : EMPTY;
      }),
    );
}
